import { render, staticRenderFns } from "./CategoriaProdutoCreate.vue?vue&type=template&id=074c04e2"
import script from "./CategoriaProdutoCreate.vue?vue&type=script&lang=js"
export * from "./CategoriaProdutoCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports